export default __webpack_public_path__ + "static/PromptIconThree-967430c4f3a75f0b5795005ba167a940.png";